import React from 'react'
import { Container } from '@material-ui/core';
import './ErrorPage.scss';

export default function ErrorPage() {
    return <Container maxWidth="lg">
        <div className="error-page-wrapper">
            <h2>Oops! Page not found</h2>
        </div>
    </Container>
}